import { message } from 'antd';
import { useEffect } from 'react';
import { motion } from 'motion/react';
import { useParams } from 'react-router-dom';
import { LoadingSpin } from '@/components';
import { useUserContext } from '@/context';
import { UserHttp } from '@/services';
import { useTranslation } from 'react-i18next';

export function LoginCasFallback() {

  const params = useParams();
  const [t] = useTranslation(['common']);
  const { loginCas, logout } = useUserContext();

  useEffect(() => {
    const access = params?.accessToken?.replace('access_token=', '');
    const refresh = params?.refreshToken?.replace('refresh_token=', '');
    if (access && refresh) {
      loginCas(access);
      setTimeout(() => {
        UserHttp.getUserProfile()
          .then(() => {
            window.location.href = '/';
          })
          .catch(() => {
            message.error({ key: 'err-auth-cas', content: t('common:errors.auth') });
            setTimeout(logout, 1200);
          });
      }, 2200);
    }
    else {
      console.log('Redirect to root');
      window.location.href = '/';
    }
  }, [params?.accessToken, params?.refreshToken, loginCas, logout, t]);

  return (
    <div
      className="flex w-full h-full text-lg items-center justify-center text-start rtl">
      <motion.div
        initial={{ y: '10px', opacity: 0 }}
        animate={{ y: '0', opacity: 1 }}
        transition={{ duration: 0.25, delay: 0.5 }}>
        <LoadingSpin text={t('common:labels.logging-in')} />
      </motion.div>
    </div>
  );
}

export default LoginCasFallback;
